module.exports = __webpack_public_path__ + "img/18-4.c79c56a4.png";